import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui';
import {
  allowedTransitions,
  isTerminal,
  type OrderStatus,
  type OrderView,
} from '@entities/order';
import { StatusChangeDialog } from './status-change-dialog';

export function StatusActions({ order }: { order: OrderView }) {
  const { t } = useTranslation();
  const [target, setTarget] = useState<OrderStatus | null>(null);

  if (isTerminal(order.status)) {
    return <p className="text-sm opacity-70">{t('orders.detail.closed')}</p>;
  }
  const transitions = allowedTransitions(order.status);
  if (transitions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {transitions.map((target) => (
        <Button
          key={target}
          type="button"
          variant={target === 'CANCELLED' ? 'destructive' : 'default'}
          size="sm"
          onClick={() => setTarget(target)}
        >
          {target === 'CANCELLED'
            ? t('orders.detail.cancelOrder')
            : t('orders.detail.moveTo', { status: t(`orders.status.${target}`) })}
        </Button>
      ))}
      {target ? (
        <StatusChangeDialog
          order={order}
          target={target}
          open={Boolean(target)}
          onOpenChange={(o) => !o && setTarget(null)}
        />
      ) : null}
    </div>
  );
}
